import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { breakpoint } from 'helpers';
import { HomeRegisterWrapper } from './Home.styled';

function HomeRegister() {
    const { t } = useTranslation();

    return (
        <HomeRegisterWrapper>
            <div className='home-register-left'>
                <div className='home-register-left-img'>
                    <img
                        src='/images/home/home-register.png'
                        alt='ลงทะเบียนใช้บริการร้านขายยาออนไลน์ PharmCare'
                        title='ลงทะเบียนเข้าใช้ pharmcare'
                    />
                </div>
            </div>
            <div className='home-register-right'>
                {/* <div className='home-register-title'>{t('home:we_are_ready_to_provide_quality_care')}</div> */}
                {/* <p>
                    {t('home:we_screen_only_the_highest_quality_pharmacies')} {t('home:to_deliver_accessible_healthcare_at_the')}{' '}
                    {t('home:highest_quality')}
                </p> */}
                <h1 className='home-register-title'>PharmCare เราพร้อมมอบบริการคุณภาพ เพื่อสุขภาพที่ดีของคุณ</h1>
                <p>
                    PharmCare แพลตฟอร์มร้านขายยาออนไลน์ และบริการส่งยาแบบ Delivery เรายินดีส่งมอบบริการสุขภาพที่ปลอดภัยเข้าถึงได้
                    เราคัดกรองร้านขายคุณภาพสูงเพื่อให้คุณได้รับบริการที่ดีที่สุด สมัครใช้งานและปรึกษาเภสัชกรผ่านแพลตฟอร์มของเราได้แล้ววันนี้
                    เพื่อการมีสุขภาพร่างกายแข็งแรง และคุณภาพชีวิตอันเป็นสุข กรอกข้อมูลของคุณ เพื่อเป็นสมาชิก
                    พร้อมรับการดูแลจากทีมเภสัชกรและทีมแพทย์ของเราได้เลย
                </p>
                <div className='home-register-link'>
                    <a
                        className='theme-btn theme-btn-info w-100 maw-300 text-decoration-none'
                        // href='/user/signup/line'
                        href='/service/telepharmacy'
                        data-test-id='signup'
                    >
                        {/* {t('home:register_now')} */}
                        {t('home:start_now')}
                    </a>
                </div>
            </div>
            <div className='home-register-bg-circle' />
        </HomeRegisterWrapper>
    );
}
export default HomeRegister;
